import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin((nuxtApp) => {
    // ถาม Sentry ตรง ๆ ว่า init ไปแล้วหรือยัง แทนการ copy เงื่อนไข dev/localhost
    // มาไว้ที่นี่อีกชุด (เงื่อนไขจริงอยู่ที่ sentry.client.config.ts ที่เดียว)
    if (!Sentry.isInitialized()) return;
    const authStore = useAuthStore();
    
    // Set user context when user is authenticated
    watch(() => authStore.isAuthenticated, (newUser) => {
        if (newUser) {
            const user = authStore.user as any;
            Sentry.setUser({
                id: authStore.storeId,
                username: user.UserName,
                storeId: authStore.storeId
            });
        }  
    }, { immediate: true });
})